export interface IAssetMapping {
  sourceAssetId: string;
  action: AssetMappingAction;
  destinationAssetId?: string;
}

export enum AssetMappingAction {
  Map = 'Map',
  Discard = 'Discard',
}
